module.exports = __webpack_public_path__ + "img/1.5ec5f367.jpg";